import { useEffect, useState } from 'react'
import { apiGetInfo } from '@ms/shared/services/api/user'
import { redirectToSocial } from '../../services/social_handoff'
import { parseCallbackToken, setAuthSession } from '../../services/auth_storage'
import {
	clearOnboardingSession,
	setOnboardingSession,
} from '../../services/onboarding_storage'

const decodeBase64Json = (value) => {
	const binary = atob(value)
	const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0))
	return JSON.parse(new TextDecoder().decode(bytes))
}

function GoogleLogin() {
	const [error, setError] = useState('')

	useEffect(() => {
		const handleCallback = async () => {
			try {
				const searchParams = new URLSearchParams(window.location.search)
				const callbackTokenValue = searchParams.get('token')
				const callbackErrorMessage = searchParams.get('message') || searchParams.get('error_description') || searchParams.get('error')
				const rawRoleId = searchParams.get('role_id')
				const roleId = rawRoleId ? Number(rawRoleId) : Number.NaN
				const onboardingDataBase64 = searchParams.get('onboarding_data')

				if (!callbackTokenValue) {
					throw new Error(callbackErrorMessage || 'ไม่พบ token จาก SSO')
				}

				const authSession = parseCallbackToken(callbackTokenValue)
				setAuthSession(authSession)
				window.history.replaceState({}, document.title, window.location.pathname)
				const userInfoResponse = await apiGetInfo()
				const userInfo = userInfoResponse?.data

				if (!userInfo || typeof userInfo !== 'object') {
					throw new Error(userInfoResponse?.message || 'ไม่สามารถโหลดข้อมูลผู้ใช้ได้')
				}

				const onboardingData = onboardingDataBase64
					? decodeBase64Json(onboardingDataBase64)
					: null
				const userRoleId = Number(userInfo.role_id)
				const resolvedRoleId = Number.isFinite(userRoleId) ? userRoleId : roleId
				const shouldContinueOnboarding = (
					userInfo.onboarding_completed_at === null
					&& Array.isArray(userInfo.platform_users)
					&& userInfo.platform_users.length === 0
				)

				if (shouldContinueOnboarding) {
					const resolvedOnboardingData = onboardingData ?? userInfo.onboarding_data ?? {}

					if (resolvedRoleId === 2) {
						setOnboardingSession({ data: resolvedOnboardingData, roleId: resolvedRoleId })
						window.location.replace('/google_login/student_onboarding')
						return
					}

					if (resolvedRoleId === 3) {
						setOnboardingSession({ data: resolvedOnboardingData, roleId: resolvedRoleId })
						window.location.replace('/google_login/teacher_onboarding')
						return
					}

					throw new Error('ประเภทผู้ใช้นี้ยังไม่มีหน้ารับข้อมูล onboarding')
				}

				clearOnboardingSession()
				await redirectToSocial()
			} catch (callbackError) {
				setError(callbackError?.message || 'เข้าสู่ระบบด้วย Google ไม่สำเร็จ')
			}
		}

		handleCallback()
	}, [])

	if (error) {
		return <main role='alert' style={{ padding: '2rem', textAlign: 'center' }}>{error}</main>
	}

	return <main style={{ padding: '2rem', textAlign: 'center' }}>กำลังเข้าสู่ระบบ...</main>
}

export default GoogleLogin
